import { useState } from "react";
import { Button, Card } from "antd";
import useCart from "grandus-lib/hooks/useCart";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import upperFirst from "lodash/upperFirst";
import toUpper from "lodash/toUpper";

import dynamic from "next/dynamic";
const TextInput = dynamic(() =>
  import("grandus-lib/components-atomic/form/TextInput")
);

import styles from "./Coupon.module.scss";
import { useTranslation } from 'next-i18next';

const Coupon = (props) => {
  const { t } = useTranslation();
  const { cart, mutateCart, isLoading, applyCoupon, removeCoupon } = useCart();

  const cartCoupon = get(cart, "coupon.hash");
  const cartHasCoupon = !isEmpty(cartCoupon);
  const [errors, setErrors] = useState(null);
  const [touched, setTouched] = useState(cartHasCoupon);
  const [value, setValue] = useState(cartCoupon);
  const [validateStatus, setValidateStatus] = useState(
    cartHasCoupon ? "success" : ""
  );
  const [helpMessage, setHelpMessage] = useState();

  const handleChange = async (e) => {
    setValue(e.target.value);
    setTouched(true);
    setErrors(null);
    if (cartHasCoupon && e.type === "click") {
      const reponse = await removeCoupon();
      mutateCart(get(reponse, "data"), false);
      setValidateStatus("");
      setHelpMessage("");
    }
  };

  const handleBlur = (e) => {
    setValue(e.target.value);
    setTouched(true);
  };

  const onApplyCouponClick = async (e) => {
    e.preventDefault();
    setTouched(true);
    setErrors(null);

    if (!value) {
      setErrors({ coupon: upperFirst(t("cart:enter coupon")) });
    }

    const response = await applyCoupon(value);
    if (!get(response, "status", true) && get(response, "message")) {
      setErrors({ coupon: get(response, "message") });
      setValidateStatus("error");
    } else {
      setValidateStatus("success");
      setHelpMessage(get(response, "message"));
    }

    mutateCart(get(response, "data"), false);
  };

  return (
    <CouponContent
      input={
        <TextInput
          label={upperFirst(t("cart:coupon"))}
          name="coupon"
          values={{ coupon: value }}
          errors={errors}
          touched={{ coupon: touched }}
          handleChange={handleChange}
          handleBlur={handleBlur}
          allowClear={true}
          disabled={isLoading}
          validateStatus={validateStatus}
          help={helpMessage}
        />
      }
      button={
        <Button
          type="primary"
          size="small"
          onClick={onApplyCouponClick}
          disabled={!value}
          loading={isLoading}
        >
          {toUpper(t("cart:ok"))}
        </Button>
      }
    />
  );
};

const CouponContent = ({ input, button }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles?.couponTitle}>
        {upperFirst(t("cart:enter coupon code"))}
      </div>
      <div className={styles.couponWrapper}>
        {input} {button}
      </div>
    </>
  );
};

export default Coupon;
